import api from './api';

export const profileAPI = {
  overview: async () => (await api.get('/profile/overview')).data,
  update: async (data) => (await api.put('/profile', data)).data,
  uploadAvatar: async (file) => {
    const form = new FormData();
    form.append('file', file);
    return (await api.post('/profile/avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  removeAvatar: async () => (await api.delete('/profile/avatar')).data,
  avatarBlob: async () => (await api.get('/profile/avatar', { responseType: 'blob' })).data,
  exportCsv: async () => (await api.get('/profile/export.csv', { responseType: 'blob' })).data,
};

export default profileAPI;
